import { v4 as uuidv4 } from 'uuid';
import shortid from 'shortid';

export default function createId(options = {}) {
  return options.short ? shortid.generate() : uuidv4();
}
